import type { StoryBeat, StoryChapterNumber, StoryLocation } from './types';
import { STORY_CHAPTERS } from './types';

export function StoryScrollProgress({ location, railHidden, onNavigate }: {
  location: StoryLocation;
  railHidden: boolean;
  onNavigate(location: StoryLocation): void;
}) {
  return <aside aria-label="ストーリー進行状況">
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[60] h-1 bg-atc-navy/10" aria-hidden="true">
      <div className="h-full origin-left bg-atc-primary will-change-transform [transform:scaleX(var(--report-scroll-progress,0))]" />
    </div>
    <nav className={`${railHidden ? 'pointer-events-none opacity-0' : 'opacity-100'} fixed right-4 top-1/2 z-40 hidden -translate-y-1/2 flex-col gap-2 rounded-full border border-atc-navy/10 bg-white/90 p-2 shadow-atc-card backdrop-blur transition-opacity xl:flex`} aria-label="章へ移動">
      {STORY_CHAPTERS.map((chapter) => {
        const current = location.chapter === chapter.number;
        return <button
          key={chapter.id}
          type="button"
          aria-label={`第${chapter.number}章 ${chapter.title}`}
          aria-current={current ? 'step' : undefined}
          onClick={() => onNavigate({ chapter: chapter.number as StoryChapterNumber, beat: 0 as StoryBeat })}
          className={`group relative grid size-9 place-items-center rounded-full text-xs font-bold transition ${current ? 'bg-atc-primary text-white' : 'text-atc-slate hover:bg-atc-surface hover:text-atc-navy'}`}
        >
          {chapter.number}
          <span className="pointer-events-none absolute right-12 w-max translate-x-2 rounded-full bg-atc-navy px-3 py-1.5 text-[11px] font-bold text-white opacity-0 transition group-hover:translate-x-0 group-hover:opacity-100 group-focus-visible:translate-x-0 group-focus-visible:opacity-100">{chapter.title}</span>
        </button>;
      })}
    </nav>
    <div className={`${railHidden ? 'opacity-0' : 'opacity-100'} pointer-events-none fixed right-4 top-4 z-40 rounded-full border border-atc-navy/10 bg-white/90 px-3 py-2 text-[11px] font-bold tabular-nums text-atc-navy shadow-sm backdrop-blur transition-opacity md:right-6`}>
      {String(location.chapter).padStart(2, '0')} / 06 ・ {location.beat + 1}/3
    </div>
  </aside>;
}
